export default __webpack_public_path__ + "static/media/Share.9b72b846.svg";